// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { GlobalValidator } from "../types";

import {
  createValidator,
  getBinding,
} from "#stdnum-runtime";

const creditcard: GlobalValidator = createValidator(
  "creditcard",
  40,
);

export default creditcard;
export const compact = creditcard.compact;
export const format = creditcard.format;
export const validate = creditcard.validate;
export type CardNetwork =
  | "visa"
  | "mastercard"
  | "amex"
  | "discover"
  | "diners"
  | "jcb"
  | "unionpay"
  | "maestro";
export const detectNetwork = (
  value: string,
): CardNetwork | null => getBinding().detectNetwork(value);
